import React, { useState, useEffect, useRef }  from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from "react-i18next";

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import { openModal } from '../../../Helpers/helpers';
import { getMazdaFeesAndLeviesDetailTitle, formatPrice, getProvince, getLang } from '../../../utils';
import { CollapseList } from '../Collapse/CollapseList';

import GTMHelper from '../../../Helpers/gtmHelper';

import { Button } from '../../1_Atoms/Button/Button';
import { Tooltip } from '../../1_Atoms/Tooltip/Tooltip';

export const CashOptions = ({ ...props }) => {
    const gtmHelper = new GTMHelper();

    const summaryCalculator = window.summaryCalculator;
    //Fixed Number provided by API
    const currentIncentives = summaryCalculator.FinancialInfo.incentive_programs.find(element => element.type === "incentive");
    const { t, i18n } = useTranslation(['payments', 'general']);
    //const [update, setForceUpdate] =  useState('');
    const [financialInfo, setFinancialInfo] = useState(summaryCalculator.FinancialInfo);
    const [reserveOpen, setReserveModalOpen] = React.useState(false);

    function getMazdaPriceDetails() {
        // TODO : THIS HAS MOVED OUT INTO A COLLAPSE BOX, I HAVE COMMENTED DURING THE MERGE FROM DEVELOP - VIET TO WILL
        
        //<li><p>${t("accessories")}<span class="accessory_legal">${t("accLegal")}</span></p><span>${formatPrice(financialInfo.calculatedCash.accessories.total, true)}</span></li>
        return  `<ul>
                    <li><p>${getMazdaFeesAndLeviesDetailTitle("Administration Fee", t)}<sup>9</sup></p><span>${formatPrice(financialInfo.adminServiceFees, true)}</span></li>
                    <li><p>${t("msrp")}</p><span>${formatPrice(summaryCalculator.SelectedModel.financial.msrp, true)}</span></li>
                    ${getOptionList()}
                    <li><p>${t("freight")}</p><span>${formatPrice(financialInfo.freight, true)}</span></li>
                    <li><p>${t("general:pde")}</p><span>${formatPrice(financialInfo.pde, true)}</span></li>
                </ul>`;

    }


    function getWheelsDetails() {
        const options = summaryCalculator.FinancialInfo ?.calculatedFinance ?.options;

        return `<ul>
                    <li><p>${`4x ${options.wheels.title}`}</p><span>${formatPrice(options.wheels.base_msrp, true)}</span></li>
                    <li><p>${`4x ${t("payments:tpms")}`}</p><span>${formatPrice(options.wheels.tpms, true)}</span></li>
                    <li><p>${t("payments:installation")}</p><span>${formatPrice(options.wheels.install_cost, true)}</span></li>
                </ul>`;
    }

    function getConnectivityDetails() {
        const selectedConnectedVehiclePackage = JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage'));
        if(selectedConnectedVehiclePackage != null && selectedConnectedVehiclePackage.title != undefined){
            const connectedPrice = (JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage')).financial.msrp);

            return `<ul>
                        <li><p>${`${selectedConnectedVehiclePackage.title}`}</p><span>${formatPrice(connectedPrice, true)}</span></li>
                    </ul>`;
        }

        return '';
    }
    
    function getAccessoriesDetails() {
        let accessories = sessionStorage.getItem(Constants.SelectedAccessories);
        accessories = JSON.parse(accessories);        
    
        let list = '<ul class="cashOptions_accessories">';
        accessories.map((accessory, index) => {
            list += `<li><p>${accessory.name}</p><span>${formatPrice(accessory.base_msrp, true)}</span></li>`
            list += `<li><p>${accessory.name} - Installation</p><span>${formatPrice(accessory.install_cost, true)}</span></li>`
        });
        list += '</ul>';
        return list;
    }

    function getProtectionDetails() {
        let list = "<ul>";

        if(summaryCalculator.SelectedAddedProtectionPackage.name != undefined ){
            list += `<li><p class="desc">${t("added_protection")} <span style="text-transform:lowercase">${summaryCalculator.SelectedAddedProtectionPackage.name}</span></p><span>${formatPrice(summaryCalculator.SelectedAddedProtectionPackage.financial.msrp, true)}</span></li>`
        }
        if(summaryCalculator.SelectedAppearanceProtectionPlan.name != undefined && summaryCalculator.SelectedAppearanceProtectionPlansIndex !== null) {

            list += `<li><p class="desc">${t("appearance_protection")} <span style="text-transform:lowercase">${summaryCalculator.SelectedAppearanceProtectionPlansPackage.name} for ${summaryCalculator.SelectedAppearanceProtectionPlan.name}</span></p><span>${formatPrice(summaryCalculator.SelectedAppearanceProtectionPlansPackage.financial.msrp, true)}</span></li>`
        }           
        list += "</ul>"
        return list;
    }

    function getMazdaFeesAndLeviesDetails() {
        const feesAndLeviesToDisplay = financialInfo.calculatedCash.feesAndLevies.detail.filter(item => item.title !== 'PDE');
        
        return `<ul>
                    ${feesAndLeviesToDisplay.map((fee, index) => `<li key="${index}">
                        <p>${getMazdaFeesAndLeviesDetailTitle(fee.title, t)}${fee.sup ? `<sup>${fee.sup}</sup>` : ''}</p><span>${formatPrice(fee.price, true)}</span>
                        </li>`).join("")}
                </ul>`;
    }

    function getMazdaFeesAndLeviesPricingWithoutPDE() {
        const total = financialInfo.calculatedCash.feesAndLevies.detail.filter(item => item.title !== 'PDE').reduce((total, fee) => total + fee.price, 0);
        return total;
    }

    function getRebatesDetails() {
        return `<ul>
                    ${financialInfo.calculatedCash.evRebates.details.map((rebate, index) => `<li key="${index}">
                        	<p class="text--green">${rebate.title==='federal'? t('fed_rebate'):t('prov_rebate') + ' ('+getProvince()+')'}</p><span class="text--green">-${formatPrice(rebate.cash, true)}</span>
                        </li>`).join("")}
                </ul>`;
    }

    function getMazdaPrice() {
        return financialInfo.calculatedCash.mazdaPrice;
    }

    function getWheelsPrice() {
        const options = summaryCalculator.FinancialInfo ?.calculatedCash ?.options;

        return options.wheels.price;
    }

    function getConnectivityPrice() {
        const connectedPrice = (JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage')).financial.msrp);

        return connectedPrice;
    }

    function getAccessoriesPrice() {
        const accessories = summaryCalculator.FinancialInfo ?.calculatedCash ?.accessories;

        return accessories.total;
    }
    
    function getProtectionPrice() {
        const protectionPrice = summaryCalculator.SelectedAddedProtectionPackage.financial.msrp + summaryCalculator.SelectedAppearanceProtectionPlansPackage.financial.msrp;
            
        return protectionPrice;
    }

    function openGetLocal(){
        const lang = getLang();
        gtmHelper.setGTM({'action':'Open Modal','modal': 'Contact Dealer'}, true, false);

        const targetModal = document.getElementById('mz-react-send-build-to-dealer-modal');
        if (targetModal && summaryCalculator) {
            if (summaryCalculator.SelectedColourExteriorIndex !== 'null' && summaryCalculator.Colours !== null) {
                const heading = targetModal.querySelector('.mz-send-build-to-dealer__vehicle-name');
                if (heading) {
                    heading.textContent = lang === 'en' ? summaryCalculator._selectedModelYear.year.title + ' ' + ReactHtmlParser(summaryCalculator._selectedModelYear.carline.title) : ReactHtmlParser(summaryCalculator._selectedModelYear.carline.title) + ' ' + summaryCalculator._selectedModelYear.year.title;
                }
            }
            openModal('mz-react-send-build-to-dealer-modal');
        }
    }

    async function handleReserveYoursClick() {
        const isRetailerMode = await summaryCalculator.isRetailerMode();
        summaryCalculator.CurrentPurchaseMethod = 'Cash';
        if (isRetailerMode) {
                setReserveModalOpen(true);
        } else {
            openGetLocal();
        }
    }

    function getCreditsDetails() {
        const currentIncentives =financialInfo.incentive_programs.find(element => element.type === "incentive");

        return `<ul class="negative">
                    ${financialInfo.calculatedCash.incentives.taxable.details.map((incentive, index) => {
                        const price = incentive.cash_value ? incentive.cash_value : incentive.value;
                            return `<li key="${index}">
                                    <p>${getIncentiveDisplayName(incentive)}</p><span>-${formatPrice(price, true)}</span>
                                </li>`;
                        }).join("")}
                    ${financialInfo.calculatedCash.incentives.nonTaxable.details.map((incentive, index) => {
                        const price = incentive.cash_value ? incentive.cash_value : incentive.value;
                            return `<li key="${index}">
                                    <p>${getIncentiveDisplayName(incentive)}</p><span>-${formatPrice(price, true)}</span>
                                </li>`;
                        }).join("")}
                    ${(currentIncentives.value > 0) ? `<li>
                        <p>${t("current_incentive")}</p>
                        <span>${currentIncentives?'-':''}${formatPrice(currentIncentives.value, true)}</span>
                    </li>`:''}
                    ${(summaryCalculator.FinancialInfo.mazdaCashIncentive > 0) ? `<li>
                        <p>${t("mazda_cash_incentive")}</p>
                        <span style="white-space: nowrap;">${summaryCalculator.FinancialInfo.mazdaCashIncentive?'-':''}${formatPrice(summaryCalculator.FinancialInfo.mazdaCashIncentive, true)}</span>
                    </li>`:''}
                    <li>
                        <p>${t("trade_in")}<sup>1</sup></p><span>${financialInfo.tradeInValue>0?'-':''}${formatPrice(financialInfo.tradeInValue, true)}</span>
                    </li>
                </ul>`;
    }

    function getIncentiveDisplayName(incentive) {
        switch(incentive.type) {
            case "loyalty" :
                return t("mazda_owner_loyalty_program");
            case "military":
                return t("mazda_military_program");
            case "grad_award":
                return t("mazda_graduate_program_award");
            case "first_time_owner":
                return t("mazda_first_time_owner");                
            default:
                return incentive.type;
        }
    }

    function getOptionList() {
        let optionList = '';
        
        const options = summaryCalculator.FinancialInfo ?.calculatedFinance ?.options;

        if(options.exteriorColour.price >0){
            optionList += ` <li class="finance-list__item">
                <p class="desc">${t('exterior')} ${options.exteriorColour.description}</p>
                <span class="price">${formatPrice(options.exteriorColour.price, true)}</span>
            </li>`
        }
        if(options ?.interiorColour.price >0){
            optionList += ` <li class="finance-list__item">
                <p class="desc">${t('interior')} ${options.interiorColour.description}</p>
                <span class="price">${formatPrice(options.interiorColour.price, true)}</span>
            </li>`
        }
        if(options ?.model_option_package ?.financial ?.msrp >0){
            optionList += ` <li class="finance-list__item">
                <p class="desc">${t('package')} ${options.model_option_package.name}</p>
                <span class="price">${formatPrice(options.model_option_package.financial.msrp, true)}</span>
            </li>`
        }
/*
        const selectedWarrantyPackage = JSON.parse(sessionStorage.getItem('selectedWarrantyPackage'));
        if(selectedWarrantyPackage != null && selectedWarrantyPackage.name != undefined ){
            const warrantyPrice = (JSON.parse(sessionStorage.getItem('selectedWarrantyPackage')).financial.msrp);
            optionList += ` <li class="finance-list__item">
                <p class="desc">${t("warranties")} ${selectedWarrantyPackage.name}</p>
                <span class="price">${formatPrice(warrantyPrice, true)}</span>
            </li>`
        }   
        
        const selectedConnectedVehiclePackage = JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage'));
        if(selectedConnectedVehiclePackage != null && selectedConnectedVehiclePackage.title != undefined){
            const connectedPrice = (JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage')).financial.msrp);
            optionList += ` <li class="finance-list__item">
                <p class="desc">${t("connected")} <span style="text-transform:lowercase">${selectedConnectedVehiclePackage.title}</span></p>
                <span class="price">${formatPrice(connectedPrice, true)}</span>
            </li>`
        }

        const selectedAddedProtectionPackage = summaryCalculator.SelectedAddedProtectionPackage;
        if(selectedAddedProtectionPackage && selectedAddedProtectionPackage.name){
            const selectedAddedProtectionPackagePrice = selectedAddedProtectionPackage.financial.msrp;
            optionList += ` <li class="finance-list__item">
                <p class="desc">${t("added_protection")} <span style="text-transform:lowercase"> ${selectedAddedProtectionPackage.name}</span></p>
                <span class="price">${formatPrice(selectedAddedProtectionPackagePrice, true)}</span>
            </li>`
        }        

        const appearanceProtectionPlan = summaryCalculator.SelectedAppearanceProtectionPlan;
        const selectedAppearanceProtectionPlansPackage = summaryCalculator.SelectedAppearanceProtectionPlansPackage; JSON.parse(sessionStorage.getItem('selectedAppearanceProtectionPlansPackage'));
        if(appearanceProtectionPlan.name && selectedAppearanceProtectionPlansPackage.name){
            const selectedAppearanceProtectionPlansPackagePrice = selectedAppearanceProtectionPlansPackage.financial.msrp;
            optionList += ` <li class="finance-list__item">
                <p class="desc">${t("appearance_protection")} <span>${appearanceProtectionPlan.name}</span>${selectedAppearanceProtectionPlansPackage.name}</p>
                <span class="price">${formatPrice(selectedAppearanceProtectionPlansPackagePrice, true)}</span>
            </li>`
        }
    
        if(options.wheels.price >0){
            optionList += ` <li class="finance-list__item">
                <p class="desc">${options.wheels.title}</p>
                <span class="price">${formatPrice(options.wheels.price, true)}</span>
            </li>`
        }*/

        return optionList;
    }

    function getCashPrice() {
        let cashPricing = null;
        if(summaryCalculator.IncludeFees){
            if(summaryCalculator.IncludeTaxes){
                if(summaryCalculator.IncludeRebates){
                    cashPricing = financialInfo.calculatedCash.subtotalWithFeesWithRebatesTaxed;
                }else{
                    cashPricing = financialInfo.calculatedCash.subtotalWithFeesTaxed;
                }
            }else{
                if(summaryCalculator.IncludeRebates){
                    cashPricing = financialInfo.calculatedCash.subtotalWithFeesWithRebatesAndEvRebates;
                }else{
                    cashPricing = financialInfo.calculatedCash.subtotalWithFees;
                }
            }
        }else{
            if(summaryCalculator.IncludeTaxes){
                if(summaryCalculator.IncludeRebates){
                    cashPricing = financialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebatesTaxed;
                }else{
                    cashPricing = financialInfo.calculatedCash.subtotalTaxed;
                }
            }else{
                if(summaryCalculator.IncludeRebates){
                    cashPricing = financialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebates;
                }else{
                    cashPricing = financialInfo.calculatedCash.subtotal;
                }
            }
        }
        return (<span>{formatPrice(cashPricing, true)}</span>);
    }
    
    function canDisplayRebates() {
        if(!summaryCalculator.IncludeRebates) 
            return false;

        return summaryCalculator.FinancialInfo.ev_rebates && summaryCalculator.FinancialInfo.ev_rebates.length > 0;
    }

    /* START HORRIBLE HACK */
    /* TODO : MOVE TRANSLATION TEXT IN RESOURCE FILE AND MAKE A GENERIC FUNCTION FOR THE SPECIALITY "WORD" */
    function isEnglish() {
        return getLang() === 'en';
    }
    
    function getDisplayableProvinceName() {
        const provinceCode = getProvince().toLowerCase();
        const provinceNames = {
            'on': { en: 'Ontario', fr: 'en Ontario' },
            'qc': { en: 'Quebec', fr: 'au Québec' },
            'ab': { en: 'Alberta', fr: 'en Alberta' },
            'bc': { en: 'British Columbia', fr: 'au Colombie Britanique' },
            'mb': { en: 'Manitoba', fr: 'au Manitoba' },
            'nb': { en: 'New Brunswick', fr: 'au Nouveau-Brunswick' },
            'nl': { en: 'Newfoundland', fr: 'à Terre-Neuve-et-Labrador' },
            'nt': { en: 'North-West Territories', fr: 'à Territoires du nord-ouest' },
            'ns': { en: 'Nova Scotia', fr: 'en Nouvelle-Écosse' },
            'nu': { en: 'Nunavut', fr: 'au Nanavut' },
            'pe': { en: 'Prince Edward Island', fr: "à l'Île-du-Prince-Édouard" },
            'sk': { en: 'Saskatchewan', fr: 'en Saskatchewan' },
            'yt': { en: 'Yukon', fr: 'au Yukon' },
        };
    
        const provinceName = provinceNames[provinceCode];
        return provinceName ? provinceName[isEnglish() ? 'en' : 'fr'] : '';
    }
    
    function getAccessoriesTooltipText() {
        const provinceName = getDisplayableProvinceName();
    
        const text = isEnglish()
            ? `Labour for installation is calculated using average labour rates in ${provinceName}.`
            : `Le coût de la main-d'œuvre pour l'installation est calculé en fonction du tarif horaire moyen ${provinceName}.`;
    
        return text;
    }

    function getTooltipText() {
        const lang = getLang();
        
        return lang === 'en' ? `Labour for installation is calculated using average labour rates in ${getDisplayableProvinceName()}.` : `Le coût de la main-d'œuvre pour l'installation est calculé en fonction du tarif horaire moyen ${getDisplayableProvinceName()}.`;
    }
     /* END HORRIBLE HACK */

    useEffect(() => {
        console.log('data has changed need a refresh cash section');

        //setForceUpdate(Math.random());
        setFinancialInfo(summaryCalculator.FinancialInfo);
    }, [summaryCalculator._tradeInValue, summaryCalculator._downPaymentValue, summaryCalculator.LoyaltyChecked, summaryCalculator.GraduateChecked, summaryCalculator.MilitaryChecked, summaryCalculator.FirstTimeOwnerChecked, summaryCalculator.IncludeFees, summaryCalculator.IncludeTaxes, summaryCalculator.IncludeRebates]);

    return (
        <div className="mz-cahs-options">
            <h4>{t("cash_purchase_price")}</h4>
            <div className="mz-cahs-options__count">
                <div className="mz-cahs-options__count-item ">
                    <div>{t("purchase_price")} <Tooltip TooltipName="purchase_price" /></div>
                    <span className='mmz-cahs-options__price'>{getCashPrice()}</span>
                    {/*{summaryCalculator.IncludeFees && summaryCalculator.IncludeTaxes && summaryCalculator.IncludeRebates ? <span className='mmz-cahs-options__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalWithFeesWithRebatesTaxed, true)}`}</span> : null}
                    {!summaryCalculator.IncludeFees && summaryCalculator.IncludeTaxes && summaryCalculator.IncludeRebates ? <span className='mmz-cahs-options__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebatesTaxed, true)}`}</span> : null}
                    {summaryCalculator.IncludeFees && !summaryCalculator.IncludeTaxes && summaryCalculator.IncludeRebates ? <span className='mmz-cahs-options__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalWithFeesWithRebatesAndEvRebates, true)}`}</span> : null}
                    {summaryCalculator.IncludeFees && summaryCalculator.IncludeTaxes && !summaryCalculator.IncludeRebates ? <span className='mmz-cahs-options__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalWithFeesTaxed, true)}`}</span> : null}
                    {summaryCalculator.IncludeFees && !summaryCalculator.IncludeTaxes && !summaryCalculator.IncludeRebates ? <span className='mmz-cahs-options__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalWithFees, true)}`}</span> : null}
                    {!summaryCalculator.IncludeFees && summaryCalculator.IncludeTaxes && !summaryCalculator.IncludeRebates ? <span className='mmz-cahs-options__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalTaxed, true)}`}</span> : null}
                    {!summaryCalculator.IncludeFees && !summaryCalculator.IncludeTaxes && summaryCalculator.IncludeRebates ? <span className='mmz-cahs-options__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebates, true)}`}</span> : null}
                    {!summaryCalculator.IncludeFees && !summaryCalculator.IncludeTaxes && !summaryCalculator.IncludeRebates ? <span className='mmz-cahs-options__price'>{`${formatPrice(financialInfo.calculatedCash.subtotal, true)}`}</span> : null}*/}

                </div>
            </div>

            <div className="mz-financial--details">
                < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={`${t('cash_price')}`} ColBoxText={getMazdaPriceDetails()} ColClassPrice="mz-collapse__price" TooltipName="detailedprice_mazdaprice"  ColPrices={`${formatPrice(getMazdaPrice(), true)}`} id={t('cash_price').replace(/[^0-9a-z]/gi, '_')} />
                
                {financialInfo ?.calculatedFinance ?.options.wheels.title ? 
                < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={t("cash_option_wheels")} ColBoxText={getWheelsDetails()} ColClassPrice="mz-collapse__price" TooltipName="" TooltipText={ReactHtmlParser(getTooltipText())} ColPrices={`${formatPrice(getWheelsPrice(), true)}`} id={t("cash_option_wheels").replace(/[^0-9a-z]/gi, '_')} />
                : null}

                {summaryCalculator.SelectedConnectedVehiclePackage.financial.msrp ?
                < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={t("cash_option_connectivity")} ColBoxText={getConnectivityDetails()} ColClassPrice="mz-collapse__price" TooltipName=""  ColPrices={`${formatPrice(getConnectivityPrice(), true)}`} id={t("cash_option_connectivity").replace(/[^0-9a-z]/gi, '_')} />
                : null }

                {financialInfo ?.calculatedFinance ?.accessories.total ? 
                < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={t("cash_option_accessories")} ColBoxText={getAccessoriesDetails()} ColClassPrice="mz-collapse__price" TooltipName="" TooltipText={getAccessoriesTooltipText()} ColPrices={`${formatPrice(getAccessoriesPrice(), true)}`} id={t("cash_option_accessories").replace(/[^0-9a-z]/gi, '_')} />
                : null }

                {summaryCalculator.SelectedAddedProtectionPackage.name || summaryCalculator.SelectedAppearanceProtectionPlansIndex !== null ?  
                < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={t("cash_option_protection")} ColBoxText={getProtectionDetails()} ColClassPrice="mz-collapse__price" TooltipName=""  ColPrices={`${formatPrice(getProtectionPrice(), true)}`} id={t("cash_option_protection").replace(/[^0-9a-z]/gi, '_')} />
                : null }                

				{canDisplayRebates() ?< CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price evRebates" ColCarText1={t("gov_rebates")} ColBoxText={getRebatesDetails()} ColClassPrice="mz-collapse__price"  ColPrices={`${financialInfo.calculatedCash.evRebates.total.cash>0?'-':''}${formatPrice(financialInfo.calculatedCash.evRebates.total.cash, true)}`} id={t("gov_rebates").replace(/[^0-9a-z]/gi, '_')} />:null}
                {summaryCalculator.IncludeFees?< CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price" ColCarText1={`${t('cash_fees')}`} ColBoxText={getMazdaFeesAndLeviesDetails()} ColClassPrice="mz-collapse__price" TooltipName="detailedprice_feesandlevies" ColPrices={`${formatPrice(getMazdaFeesAndLeviesPricingWithoutPDE(), true)}`}  id={t("cash_fees").replace(/[^0-9a-z]/gi, '_')} />:null}
                {summaryCalculator.IncludeTaxes?<div className="mz-financial__non-collapse"><div className="mz-financial__non-collapse__title">{t("taxes")}</div>
                    { summaryCalculator.IncludeFees && summaryCalculator.IncludeTaxes &&  summaryCalculator.IncludeRebates ? <span className='mz-financial__non-collapse__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalWithFeesWithRebatesTaxes, true)}`}</span> : null}
                    {!summaryCalculator.IncludeFees && summaryCalculator.IncludeTaxes &&  summaryCalculator.IncludeRebates ? <span className='mz-financial__non-collapse__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebatesTaxes, true)}`}</span> : null}
                    { summaryCalculator.IncludeFees && summaryCalculator.IncludeTaxes && !summaryCalculator.IncludeRebates ? <span className='mz-financial__non-collapse__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalWithFeesTaxes, true)}`}</span> : null}
                    {!summaryCalculator.IncludeFees && summaryCalculator.IncludeTaxes && !summaryCalculator.IncludeRebates ? <span className='mz-financial__non-collapse__price'>{`${formatPrice(financialInfo.calculatedCash.subtotalTaxes, true)}`}</span> : null}
                </div>:null}
                < CollapseList CollapseClasses="mz-collapse__button mz-collapse__button--transparent mz-collapse__button--price negative" ColCarText1={`${t('cash_credits')}`} TooltipName="detailedprice_credit" ColBoxText={getCreditsDetails()} ColClassPrice="mz-collapse__price" ColPrices={`${currentIncentives.value + financialInfo.calculatedCash.incentives.taxable.total + financialInfo.calculatedCash.incentives.nonTaxable.total + financialInfo.tradeInValue + summaryCalculator.FinancialInfo.mazdaCashIncentive >0?'-':''}${formatPrice(currentIncentives.value + financialInfo.calculatedCash.incentives.taxable.total + financialInfo.calculatedCash.incentives.nonTaxable.total + financialInfo.tradeInValue + summaryCalculator.FinancialInfo.mazdaCashIncentive, true)}`} id={t("cash_credits").replace(/[^0-9a-z]/gi, '_')} />
                <div className="mz-financial__non-collapse negative"><div className="mz-financial__non-collapse__title">{t("down_payment")}<sup>2</sup> <Tooltip TooltipName="detailedprice_downpayment" /></div><span className="mz-financial__non-collapse__price">{financialInfo.downPaymentValue > 0 ? '-':''}{formatPrice(financialInfo.downPaymentValue, true)}</span></div>
                <div className="mz-financial--cta hidden">
                    <Button primary={true} label={String(t("summary:btn_reserve_yours"))} iconBefore={false} onClick={handleReserveYoursClick}/>
                </div>
                <div className="mz-spacer mz-spacer-s"></div>
            </div>
        </div>
    )
}
//ev_rebates >0? evRebate.getRebate(ev_rebates, 'general', true)